import React from 'react'

import PropTypes from 'prop-types'

import SegmentSelector, {
  AcademicProfileSelector,
  DemographicsSelector,
  EngagementStageSelector,
  FocusAndCareerSelector,
  GraduationYearSelector,
  HighSchoolSegmentSelector,
  InterestsSegmentSelector,
  KnownStudentSelector,
  LegalSexSection,
  LocationSelector,
  ManualStudentSelector,
} from 'components/SegmentSelector'
import { ONE_TIME_TRIGGER } from 'components/SegmentSelector/outreach-message-trigger-constants'
import { getIsUsingManualStudentSelection, getIsUsingMyMatches } from 'components/SegmentSelector/segment-service'
import { useAppSelector } from 'store'

import FilterSegmentToggle from './FilterSegmentToggle'

const StudentSegmentation = ({ trigger, segment, onChange, onError }) => {
  const isOneTimeMessage = trigger === ONE_TIME_TRIGGER
  const isUsingMyMatches = getIsUsingMyMatches(segment)
  const isPremiumSegmentationEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsPremiumMessagingOptions || false,
  )

  const isUsingManualStudentSelection = getIsUsingManualStudentSelection(segment)
  return (
    <SegmentSelector
      trigger={trigger}
      segment={segment}
      onChange={onChange}
    >
      {isUsingManualStudentSelection ? (
        <ManualStudentSelector />
      ) : (
        <FilterSegmentToggle>
          {isOneTimeMessage && !isUsingMyMatches && <EngagementStageSelector onError={onError} />}
          <GraduationYearSelector onError={onError} />
          {isPremiumSegmentationEnabled && <KnownStudentSelector />}
          <FocusAndCareerSelector />
          <InterestsSegmentSelector />
          <DemographicsSelector />
          <LegalSexSection />
          <LocationSelector />
          <HighSchoolSegmentSelector />
          <AcademicProfileSelector />
        </FilterSegmentToggle>
      )}
    </SegmentSelector>
  )
}

StudentSegmentation.propTypes = {
  trigger: PropTypes.string,
  segment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
}

export default StudentSegmentation
